<template>
    <div class="fluid">
        <h1 class="app-title">Migração e Edição de EF</h1>
        <b-card>
            <b-row no-gutters>
                <b-col md="12" no-gutters>
                    <form-wizard
                            ref="wizard"
                            nextButtonText="Próximo"
                            backButtonText="Anterior"
                            finishButtonText="Concluir"
                            title
                            subtitle
                            color="#004262" >
                        <wizard-step
                                slot-scope="props"
                                slot="step"
                                :tab="props.tab"
                                :index="props.index"
                        ></wizard-step>
                        <tab-content
                                icon="fa fa-search"
                                class="mx-auto"
                                title="Escolha um dos três modos de pesquisa e informe os parâmetros da pesquisa">
                            <ParametrosPesquisa
                                    :filtros="filtros"
                                    @consultar="consultar"
                                    :validations="validations"/>
                        </tab-content>
                        <tab-content
                                icon="fa fa-file-text-o"
                                class="mx-auto"
                                title="Resultado da Pesquisa" >
                            <TabelaPesquisas
                                    :resultado="resultado"
                                    :configTable="configTable"
                                    :filtros="filtros"
                                    :selecteds="selecteds"
                                    @openFilterPopup="openFilterPopup"
                                    @consultar="consultar"
                                    @limparFiltros="limparFiltros"/>
                        </tab-content>

                        <template slot="footer" slot-scope="props" class="pb-0">
                            <hr class="mt-0 mb-2"/>
                            <div class="row justify-content-center">
                                <div class="d-flex justify-content-between mb-3">
                                    <div v-if="props.activeTabIndex == 0">
                                        <b-button
                                                id="btnProxima"
                                                @click="pesquisar"
                                                variant="primary">
                                            Pesquisar
                                        </b-button>
                                    </div>
                                    <div v-if="props.activeTabIndex == 1">
                                        <b-button
                                                @click="voltar" style="float: left"
                                                variant="secondary">
                                            <i class="fa fa-arrow-left"></i>
                                            Voltar
                                        </b-button>
                                        <b-button class="ml-2" variant="primary" @click.prevent="showModalIncluir" :disabled="selecteds.length !== 1">
                                            <i class="fa fa-plus"></i> Incluir
                                        </b-button>
                                        <b-button class="ml-2" variant="primary" style="color: #FFF" @click.prevent="showModalIncluirMni">
                                            <i class="fa fa-plus"></i> Incluir processo via MNI
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </form-wizard>
                </b-col>
            </b-row>
        </b-card>
        
        <b-modal ref="modalIncluir" size="lg" title="Informar CPF/CNPJ" cancel-title="Fechar">
            <b-alert variant="danger" :show="msgErroFormulario">{{ msgErroFormulario }}</b-alert>

            <b-row class="mt-3" v-for="devedor in fichaProcessoEdicao.devedores">
                <b-col md="12">
                    <b-form-group
                            label="Nome: *"
                            label-for="cpf"
                            class="text-label required">
                        <b-form-input
                                type="text"
                                maxlength="100"
                                v-model="devedor.nome"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col md="12">
                    <b-form-group
                            label="CPF / CNPJ: *"
                            label-for="cpf"
                            class="text-label required">
                        <b-form-input
                                type="text"
                                data-vv-as="CPF"
                                v-model="devedor.documento"
                                v-mask="['XXX.XXX.XXX-XX', 'XX.XXX.XXX/XXXX-##']"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{  }">
                <div class="d-flex justify-content-between">
                    <b-button variant="secondary" class="fonte-branca" @click="hideModalIncluir">
                        <i class="fa fa-arrow-left"></i> Cancelar
                    </b-button>
                    <b-button size="md" variant="primary" @click="incluirDados" class="float-left ml-2">
                        <i class="fa fa-save"></i> Salvar e Migrar
                    </b-button>
                </div>
            </template>
        </b-modal>

        <b-modal ref="modalIncluirMni" size="lg" title="Inclusão processo via MNI" cancel-title="Fechar">
            <b-alert variant="danger" :show="msgErroFormulario">{{ msgErroFormulario }}</b-alert>

            <b-row class="mt-3">
                <b-col md="12">
                    <p class="mb-2">
                        Número do processo:
                        <span class="text-danger">*</span>
                        <i class="fa fa-info-circle fa-12x text-info ml-2" variant="info"
                           v-b-popover.hover.top="'Informe um número de processo por linha'">
                        </i>
                    </p>
                    <b-form-textarea
                            id="numerosCda"
                            v-model="processos"
                            placeholder=""
                            max-rows="10"
                            style="max-height: 220px;"
                    ></b-form-textarea>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{  }">
                <div class="d-flex justify-content-between">
                    <b-button variant="secondary" class="fonte-branca ml-1" @click="hideModalIncluirMni">
                        <i class="fa fa-arrow-left"></i> Cancelar
                    </b-button>
                    <b-button size="md" variant="primary" @click="incluirProcessos" class="float-left">
                        <i class="fa fa-save"></i> Salvar
                    </b-button>
                </div>
            </template>
        </b-modal>

        <CompFiltroGrid
                ref="compFiltro"
                :filtro="filtro"
                @filtrarResultados="filtrarResultados"
                @ordenarResultados="ordenarResultados"/>
    </div>
</template>

<script>
    import {FormWizard, TabContent, WizardStep} from 'vue-form-wizard';

    import axios from 'axios';
    import 'vue-form-wizard/dist/vue-form-wizard.min.css';
    import ParametrosPesquisa from "./components/ParametrosPesquisa";
    import TabelaPesquisas from "./components/TabelaPesquisas";
    import CompFiltroGrid from "../shared/components/CompFiltroGrid";
    import formatarMixins from '../../mixins/formatarMixins';
    import validacoesUtil from '../../util/validacoesUtil';

    export default {
        components: {
            ParametrosPesquisa,
            TabelaPesquisas,
            FormWizard,
            TabContent,
            WizardStep,
            CompFiltroGrid
        },
        mixins: [ formatarMixins ],
        data() {
            return {
                urlApi: null,
                token: null,
                carregando: false,
                configTable: {
                    perPage: 10,
                    sortField: 'fp.datahorainclusao',
                    sortOrder: 'desc',
                    currentPage: 1,
                    rows: 0,
                    checkedAll: false,
                    load: false,
                    totalGeral: 0,
                    quantidadeGeral: 0,
                    totalProcessos: 0,
                    visible: false
                },
                resultado: [],
                selecteds: [],
                showColunms: [],
                fichaProcessoEdicao: {
                    devedores: []
                },
                processos: null,
                msgErroFormulario: null,
                filtro: {
                    tipo: null,
                    campoFiltro: null,
                    filtrarEm: null,
                    campoValor: null,
                    campoMascara: null,
                    listaValores: []
                },
                filtros: {
                    cnj: null,
                    cnjEdicao: null,
                    cpfCnpj: null,
                    nomeDevedor: null,
                    dataInicio: null,
                    dataFinal: null,
                    filtrarDataCriacaoDivida: null,
                    dataCriacaoDivida: null,
                    cnjSub: null,
                    cda: null,
                    filtrarDevedor: null,
                    devedor: null,
                    cpfCnpjSub: null,
                },
                load: false,
                validations: {
                    cnj: { valid: true, message: "" },
                    cnjEdicao: { valid: true, message: "" },
                    nome: { valid: true, message: "" },
                    cpfCnpj: { valid: true, message: "" },
                    dataInicio: { valid: true, message: "" },
                    dataFinal: { valid: true, message: "" }
                },
            }
        },
        methods: {
            async pesquisar() {
                if(this.filtros.cnjEdicao != null && this.filtros.cnjEdicao != ""){
                    if(this.filtros.cnjEdicao.length < 25 || !this.validaCnj(this.filtros.cnjEdicao)) {
                        validacoesUtil.adicionarErroDeValidacao(this.validations.cnjEdicao, "Processo inexistente na base do PROAJU ou número inválido");
                    }else{
                        this.redirecionarParaTelaDeEdicaoDeProcesso();
                    }
                    return;
                }

                this.filtros = {
                    cnj: this.filtros.cnj,
                    cpfCnpj: this.filtros.cpfCnpj,
                    nomeDevedor: this.filtros.nomeDevedor,
                    dataInicio: this.filtros.dataInicio,
                    dataFinal: this.filtros.dataFinal,
                    filtrarDataCriacaoDivida: null,
                    dataCriacaoDivida: null,
                    cnjSub: null,
                    cda: null,
                    filtrarDevedor: null,
                    devedor: null,
                    cpfCnpjSub: null
                };

                this.$store.commit("setMessages", {});
                validacoesUtil.limparValidacao(this.validations);

                if(this.filtros.cnj != null && this.filtros.cnj != "" && (this.filtros.cnj.length < 25 || !this.validaCnj(this.filtros.cnj))) {
                    validacoesUtil.adicionarErroDeValidacao(this.validations.cnj, "CNJ inválido.");
                    return;
                }

                this.$refs.wizard.nextTab();

                this.selecteds = [];

                this.configTable.visible = true;
				this.configTable.rows = -1;
                this.consultar();
            },
            async voltar() {
                this.$refs.wizard.reset();
            },

            async consultar() {
                let perPageStr = `&perPage=${this.configTable.perPage}`;
                if (this.configTable.perPage === 'Todos') {
                    perPageStr = '';
                    this.configTable.currentPage = 1;
                    this.configTable.rows = 0;
                }

                let filtrosPesquisa = {
                    ...this.filtros
                };

                if (document.getElementsByClassName('vs__input').length > 0
                        && document.getElementsByClassName('vs__input')[0] != null
                        && document.getElementsByClassName('vs__input')[0].value != ""){
                    filtrosPesquisa.nomeDevedor = document.getElementsByClassName('vs__input')[0].value;
                } else {
                    filtrosPesquisa.nomeDevedor = '';
                }

                this.configTable.load = true;
                
                axios.post(`${this.urlApi}/v1/processosDigitalizados/consultar?page=${this.configTable.currentPage}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}&perPage=${this.configTable.perPage}&rows=${this.configTable.rows}`, filtrosPesquisa, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                })
                .then(response => {
                    this.resultado = response.data.resultado;
                    this.configTable.rows = response.data.rows;

                    this.configTable.checkedAll = true;
                    this.resultado.forEach(result => {
                        result.checked = false;
                        this.selecteds.forEach(selected => {
                            if(result.codFichaProcesso == selected.codFichaProcesso) {
                                const index = this.selecteds.indexOf(selected);
                                this.selecteds.splice(index, 1);

                                this.selecteds.push(result);
                                result.checked = true;
                            }
                        });

                        if(!this.selecteds.includes(result)) {
                            this.configTable.checkedAll = false
                        }
                    });
                }).finally(() => {
                    this.configTable.load = false;
                });
            },

            openFilterPopup(campo, tipo, values, mascara, event) {
                if(document.getElementById('popup').style.display == 'block'
                    && this.filtro.campoFiltro == campo) {
                    this.$refs.compFiltro.closeFilterPopup();
                } else {
                    this.filtro.tipo = tipo;
                    this.filtro.campoFiltro = campo;
                    this.filtro.mascara = mascara;

                    if(this.filtro.campoFiltro == 'Número CNJ') {
                        this.filtro.campoMascara = this.filtros.cnjSub;
                    } else if(this.filtro.campoFiltro == 'Nome Devedor') {
                        this.filtro.filtrarEm = this.filtros.filtrarDevedor;
                        this.filtro.campoValor = this.filtros.devedor;
                    } else if(this.filtro.campoFiltro == 'Documento Devedor') {
                        this.filtro.campoMascara = this.filtros.cpfCnpjSub;
                    } else if(this.filtro.campoFiltro == 'CDA\'s') {
                        this.filtro.campoMascara = this.filtros.cda;
                    } else if(this.filtro.campoFiltro == 'Data de Criação da Ficha') {
                        this.filtro.filtrarEm = this.filtros.filtrarDataCriacaoDivida;
                        this.filtro.campoValor = this.filtros.dataCriacaoDivida;
                    }

                    if(this.filtro.tipo == "checkbox") {
                        this.filtro.listaValores = values;
                    } else if(values != null && values != "") {
                        this.filtro.listaValores = values.split(',');
                    }

                    this.$refs.compFiltro.openCloseFilterPopup(event);
                }
            },
            filtrarResultados(limpar) {
                if(limpar) {
                    this.filtro.filtrarEm = null;
                    this.filtro.campoValor = null;
                    this.filtro.campoMascara = null;
                }

                if(this.filtro.campoFiltro == 'Número CNJ') {
                    this.filtros.cnjSub = this.filtro.campoMascara;
                } else if(this.filtro.campoFiltro == 'Nome Devedor') {
                    this.filtros.filtrarDevedor = this.filtro.filtrarEm;
                    this.filtros.devedor = this.filtro.campoValor;
                } else if(this.filtro.campoFiltro == 'Documento Devedor') {
                    this.filtros.cpfCnpjSub = this.filtro.campoMascara;
                } else if(this.filtro.campoFiltro == 'CDA\'s') {
                    this.filtros.cda = this.filtro.campoMascara;
                } else if(this.filtro.campoFiltro == 'Data de Criação da Ficha') {
                    this.filtros.filtrarDataCriacaoDivida = this.filtro.filtrarEm;
                    this.filtros.dataCriacaoDivida = this.filtro.campoValor;
                }

                this.configTable.currentPage = 1;

                this.consultar();
            },
            ordenarResultados(order) {
                if(this.filtro.campoFiltro == 'Número CNJ') {
                    this.configTable.sortField = 'id.cnj';
                } else if(this.filtro.campoFiltro == 'Nome Devedor') {
                    this.configTable.sortField = 'devedor';
                } else if(this.filtro.campoFiltro == 'Documento Devedor') {
                    this.configTable.sortField = 'documento';
                } else if(this.filtro.campoFiltro == 'CDA\'s') {
                    this.configTable.sortField = 'cda';
                } else if(this.filtro.campoFiltro == 'Data de Criação da Ficha') {
                    this.configTable.sortField = 'fp.datahorainclusao';
                }

                this.configTable.sortOrder = order;

                this.consultar();
            },
            limparFiltros() {
                this.filtros = {
                    numeroDivida: this.filtros.numeroDivida,
                    cnj: this.filtros.cnj,
                    cpfCnpj: this.filtros.cpfCnpj,
                    nomeDevedor: this.filtros.nomeDevedor,
                    dataInicio: this.filtros.dataInicio,
                    dataFinal: this.filtros.dataFinal,
                    filtrarDataCriacaoDivida: null,
                    dataCriacaoDivida: null,
                    cnjSub: null,
                    cda: null,
                    filtrarDevedor: null,
                    devedor: null,
                    cpfCnpjSub: null,
                };

                this.consultar();
            },

            showModalIncluir() {
                this.msgErroFormulario = null;

                this.fichaProcessoEdicao = {
                    ...this.selecteds[0]
                };

                this.$refs['modalIncluir'].show();
            },

            hideModalIncluir() {
                this.$refs['modalIncluir'].hide();
            },

            showModalIncluirMni() {
                this.msgErroFormulario = null;
                this.processos = null;

                this.$refs['modalIncluirMni'].show();
            },

            hideModalIncluirMni() {
                this.$refs['modalIncluirMni'].hide();
            },

            incluirDados() {
                this.$store.commit("setMessages", {});
                validacoesUtil.limparValidacao(this.validations);

                this.msgErroFormulario = null;

                for(var i = 0; i < this.fichaProcessoEdicao.devedores.length; i++) {
                    if(this.fichaProcessoEdicao.devedores[i].nome == null || this.fichaProcessoEdicao.devedores[i].nome.trim() == '') {
                        this.msgErroFormulario = "Favor preencher os campos obrigatórios!";
                        return;
                    }
                    if(this.fichaProcessoEdicao.devedores[i].documento == null || this.fichaProcessoEdicao.devedores[i].documento.trim() == '') {
                        this.msgErroFormulario = "Favor preencher os campos obrigatórios!";
                        return;
                    } else if(this.fichaProcessoEdicao.devedores[i].documento.length <= 14 && !this.validarCpf(this.fichaProcessoEdicao.devedores[i].documento, true)) {
                        this.msgErroFormulario = "CPF inválido!";
                        return;
                    } else if(this.fichaProcessoEdicao.devedores[i].documento.length > 14 && !this.validarCNPJAlfanumerico(this.fichaProcessoEdicao.devedores[i].documento, true)) {
                        this.msgErroFormulario = "CNPJ inválido!";
                        return;
                    }
                }

                this.hideModalIncluir();

                this.configTable.load = true;
                axios.post(`${this.urlApi}/v1/processosDigitalizados/migrar`, this.fichaProcessoEdicao, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(() => {
                    this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: ['Operação realizada com sucesso!!!'] });
                    this.selecteds = [];
                    window.scrollTo(0,0);
                }).catch((error) => {
                    this.exibirErro(error);
                }).finally(() => {
                    this.configTable.load = false;
                    this.consultar();
                });
            },

            incluirProcessos() {
                this.msgErroFormulario = null;

                if(this.processos == null || this.processos.trim() == '') {
                    this.msgErroFormulario = "Favor preencher os campos obrigatórios!";
                    return;
                }

                this.configTable.load = true;
                axios.post(`${this.urlApi}/v1/processosDigitalizados/incluirProcessos?sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, this.processos, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    },
                    responseType: 'arraybuffer'
                }).then(response => {
                    this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: ['Operação realizada com sucesso!!!'] });
                    this.selecteds = [];
                    window.scrollTo(0,0);
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.hideModalIncluirMni();
                    this.configTable.load = false;
                    this.consultar();
                });
            },
            redirecionarParaTelaDeEdicaoDeProcesso() {
                if(!this.carregando) {
                    this.carregando = true;
                    axios.get(`${this.urlApi}/v1/processosDigitalizados/${this.filtros.cnjEdicao}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': this.token
                        }
                    }).then(response => {
                        if (response.data != null && response.data.processoMigradoVO != null) {
                            this.$store.commit('setCnj', this.filtros.cnjEdicao);
                            this.$router.push('migracao/processo/editar');
                        } else {
                            validacoesUtil.adicionarErroDeValidacao(this.validations.cnjEdicao, "Processo inexistente na base do PROAJU ou número inválido.");
                        }
                    }).catch((error) => {
                        this.exibirErro(error)
                    }).finally(() => {
                        this.carregando = false;
                    })
                }
            }
        },
        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;
        },
    }
</script>
